import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import SEO from "../utils/SEO";

// E-E-A-T trust page linked from every article byline. Explains how Sarv researches
// and reviews its content — honest, wellness-framed, no fabricated credentials.
const EditorialProcess = () => (
  <Container style={{ paddingTop: "110px", paddingBottom: "90px", maxWidth: "820px" }}>
    <SEO
      title="Our Editorial Process — How Sarv Researches Herbal Content"
      description="How the Sarv Health Team researches, writes, and reviews our herbal-medicine and natural-remedy content — grounded in peer-reviewed research and traditional herbalism, with clear sourcing and disclaimers."
      canonicalPath="/editorial-process"
      keywords="Sarv editorial process, herbal content accuracy, evidence-based herbalism, medical disclaimer"
    />

    <h1 style={{ fontFamily: "Canela", color: "#0a0a39" }}>Our Editorial Process</h1>
    <p style={{ fontSize: "18px", lineHeight: 1.6 }}>
      Sarv's mission is to make trustworthy, natural-health education accessible. Every article
      in our library is researched and reviewed by the <strong>Sarv Health Team</strong> using
      the standards below.
    </p>

    <h2 style={{ fontFamily: "Canela", marginTop: "28px" }}>How we research</h2>
    <ul style={{ fontSize: "18px", lineHeight: 1.7 }}>
      <li>
        We draw on <strong>peer-reviewed research</strong>, established pharmacology and
        phytotherapy references, and respected traditional herbalism texts.
      </li>
      <li>
        Every article lists its <strong>Sources</strong> so you can verify the information
        yourself.
      </li>
      <li>
        We note <strong>contraindications, interactions, and safety cautions</strong> wherever
        they apply, not just benefits.
      </li>
    </ul>

    <h2 style={{ fontFamily: "Canela", marginTop: "28px" }}>How we review &amp; update</h2>
    <ul style={{ fontSize: "18px", lineHeight: 1.7 }}>
      <li>Content is checked for accuracy and clarity before publishing.</li>
      <li>
        Articles show a <strong>&ldquo;Last updated&rdquo;</strong> date; we revise them as
        guidance and evidence evolve.
      </li>
      <li>
        Spot an error?{" "}
        <Link to="/contact">Tell us</Link> — we take corrections seriously.
      </li>
    </ul>

    <h2 style={{ fontFamily: "Canela", marginTop: "28px" }}>Our promise on medical claims</h2>
    <p style={{ fontSize: "18px", lineHeight: 1.6 }}>
      Sarv provides <strong>wellness and educational information</strong>, not medical advice,
      diagnosis, or treatment. Herbs can be powerful and can interact with medications and
      conditions. Always consult a qualified healthcare provider before starting any herb —
      especially if you are pregnant, nursing, managing a health condition, or taking
      medication.
    </p>

    <p style={{ fontSize: "16px", color: "#555", marginTop: "28px" }}>
      Want personalized, natural recommendations for your body and goals?{" "}
      <Link to="/start">Get your personalized plan →</Link>
    </p>
  </Container>
);

export default EditorialProcess;
